export var Commonv2_ErrCode = function () {
  //__ENUM_IIFE__
  var Commonv2_ErrCode;

  (function (Commonv2_ErrCode) {
    Commonv2_ErrCode[Commonv2_ErrCode["Success"] = 0] = "Success";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrTagDupCreate"] = 124001] = "ErrTagDupCreate";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrTagNotFound"] = 124002] = "ErrTagNotFound";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrTagDupSet"] = 124003] = "ErrTagDupSet";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryDupCreate"] = 124004] = "ErrCategoryDupCreate";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryNotFound"] = 124005] = "ErrCategoryNotFound";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryDupSet"] = 124006] = "ErrCategoryDupSet";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryParentNotFound"] = 124007] = "ErrCategoryParentNotFound";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryParentHasDisable"] = 124008] = "ErrCategoryParentHasDisable";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryInvalidParentId"] = 114005] = "ErrCategoryInvalidParentId";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryNotLeaf"] = 114008] = "ErrCategoryNotLeaf";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryCanNotMove"] = 114009] = "ErrCategoryCanNotMove";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrInvalidCategoryTree"] = 114010] = "ErrInvalidCategoryTree";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCategoryNameExisted"] = 114011] = "ErrCategoryNameExisted";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrBannerDupCreate"] = 124009] = "ErrBannerDupCreate";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrBannerDupSet"] = 124010] = "ErrBannerDupSet";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrBannerNotFound"] = 124011] = "ErrBannerNotFound";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrAsyncTaskNotFound"] = 124012] = "ErrAsyncTaskNotFound";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrAsyncTaskFailure"] = 124013] = "ErrAsyncTaskFailure";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrIdentityCertConfigNotFound"] = 124014] = "ErrIdentityCertConfigNotFound";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrUnsupportedTaskArgs"] = 124015] = "ErrUnsupportedTaskArgs";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrRequestExternalInterfaceFailed"] = 124016] = "ErrRequestExternalInterfaceFailed";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrHtmlParseFail"] = 124018] = "ErrHtmlParseFail";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrRequestUrlFail"] = 124019] = "ErrRequestUrlFail";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrHtmlIpFail"] = 124020] = "ErrHtmlIpFail";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrCloudConfigNotFound"] = 124021] = "ErrCloudConfigNotFound";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrIp2GEOLocation"] = 124022] = "ErrIp2GEOLocation";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrParamInvalid"] = 124023] = "ErrParamInvalid";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrTCLbsUnknownWrong"] = 124024] = "ErrTCLbsUnknownWrong";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrInvalidToken"] = 124025] = "ErrInvalidToken";
    Commonv2_ErrCode[Commonv2_ErrCode["ErrUnknown"] = 124026] = "ErrUnknown";
  })(Commonv2_ErrCode || (Commonv2_ErrCode = {}));

  return Commonv2_ErrCode;
}();
export var Commonv2_ModelTag_PrivilegeType = function () {
  //__ENUM_IIFE__
  var Commonv2_ModelTag_PrivilegeType;

  (function (Commonv2_ModelTag_PrivilegeType) {
    Commonv2_ModelTag_PrivilegeType[Commonv2_ModelTag_PrivilegeType["PrivilegeTypeNil"] = 0] = "PrivilegeTypeNil";
    Commonv2_ModelTag_PrivilegeType[Commonv2_ModelTag_PrivilegeType["PrivilegeTypePublic"] = 1] = "PrivilegeTypePublic";
    Commonv2_ModelTag_PrivilegeType[Commonv2_ModelTag_PrivilegeType["PrivilegeTypePrivately"] = 2] = "PrivilegeTypePrivately";
  })(Commonv2_ModelTag_PrivilegeType || (Commonv2_ModelTag_PrivilegeType = {}));

  return Commonv2_ModelTag_PrivilegeType;
}();
export var Commonv2_ModelIdentityCertType_IdentityCertType = function () {
  //__ENUM_IIFE__
  var Commonv2_ModelIdentityCertType_IdentityCertType;

  (function (Commonv2_ModelIdentityCertType_IdentityCertType) {
    Commonv2_ModelIdentityCertType_IdentityCertType[Commonv2_ModelIdentityCertType_IdentityCertType["IdentityCertTypeNil"] = 0] = "IdentityCertTypeNil";
    Commonv2_ModelIdentityCertType_IdentityCertType[Commonv2_ModelIdentityCertType_IdentityCertType["IdentityCertTypeIdFace"] = 1] = "IdentityCertTypeIdFace";
  })(Commonv2_ModelIdentityCertType_IdentityCertType || (Commonv2_ModelIdentityCertType_IdentityCertType = {}));

  return Commonv2_ModelIdentityCertType_IdentityCertType;
}();
export var Commonv2_ModelIdentityCertAccount_ProviderType = function () {
  //__ENUM_IIFE__
  var Commonv2_ModelIdentityCertAccount_ProviderType;

  (function (Commonv2_ModelIdentityCertAccount_ProviderType) {
    Commonv2_ModelIdentityCertAccount_ProviderType[Commonv2_ModelIdentityCertAccount_ProviderType["ProviderTypeNil"] = 0] = "ProviderTypeNil";
    Commonv2_ModelIdentityCertAccount_ProviderType[Commonv2_ModelIdentityCertAccount_ProviderType["ProviderTypeNuoZhengTong"] = 1] = "ProviderTypeNuoZhengTong";
  })(Commonv2_ModelIdentityCertAccount_ProviderType || (Commonv2_ModelIdentityCertAccount_ProviderType = {}));

  return Commonv2_ModelIdentityCertAccount_ProviderType;
}();
export var Commonv2_ModelImageCheckAccount_ProviderType = function () {
  //__ENUM_IIFE__
  var Commonv2_ModelImageCheckAccount_ProviderType;

  (function (Commonv2_ModelImageCheckAccount_ProviderType) {
    Commonv2_ModelImageCheckAccount_ProviderType[Commonv2_ModelImageCheckAccount_ProviderType["ProviderTypeNil"] = 0] = "ProviderTypeNil";
    Commonv2_ModelImageCheckAccount_ProviderType[Commonv2_ModelImageCheckAccount_ProviderType["ProviderTypeTuputech"] = 1] = "ProviderTypeTuputech";
  })(Commonv2_ModelImageCheckAccount_ProviderType || (Commonv2_ModelImageCheckAccount_ProviderType = {}));

  return Commonv2_ModelImageCheckAccount_ProviderType;
}();
export var Commonv2_ModelImageCheckAccount_CheckFlag = function () {
  //__ENUM_IIFE__
  var Commonv2_ModelImageCheckAccount_CheckFlag;

  (function (Commonv2_ModelImageCheckAccount_CheckFlag) {
    Commonv2_ModelImageCheckAccount_CheckFlag[Commonv2_ModelImageCheckAccount_CheckFlag["CheckFlagNil"] = 0] = "CheckFlagNil";
    Commonv2_ModelImageCheckAccount_CheckFlag[Commonv2_ModelImageCheckAccount_CheckFlag["CheckFlagPorn"] = 1] = "CheckFlagPorn";
  })(Commonv2_ModelImageCheckAccount_CheckFlag || (Commonv2_ModelImageCheckAccount_CheckFlag = {}));

  return Commonv2_ModelImageCheckAccount_CheckFlag;
}();
export var Commonv2_TaskType = function () {
  //__ENUM_IIFE__
  var Commonv2_TaskType;

  (function (Commonv2_TaskType) {
    Commonv2_TaskType[Commonv2_TaskType["TaskTypeNil"] = 0] = "TaskTypeNil";
    Commonv2_TaskType[Commonv2_TaskType["TaskTypeSync"] = 1] = "TaskTypeSync";
    Commonv2_TaskType[Commonv2_TaskType["TaskTypeExport"] = 2] = "TaskTypeExport";
    Commonv2_TaskType[Commonv2_TaskType["TaskTypeImport"] = 3] = "TaskTypeImport";
    Commonv2_TaskType[Commonv2_TaskType["TaskTypeDownload"] = 4] = "TaskTypeDownload";
    Commonv2_TaskType[Commonv2_TaskType["TaskTypeSet"] = 5] = "TaskTypeSet";
  })(Commonv2_TaskType || (Commonv2_TaskType = {}));

  return Commonv2_TaskType;
}();
export var Commonv2_TagListOption = function () {
  //__ENUM_IIFE__
  var Commonv2_TagListOption;

  (function (Commonv2_TagListOption) {
    Commonv2_TagListOption[Commonv2_TagListOption["TagListOptionNil"] = 0] = "TagListOptionNil";
    Commonv2_TagListOption[Commonv2_TagListOption["TagListOptionName"] = 1] = "TagListOptionName";
    Commonv2_TagListOption[Commonv2_TagListOption["TagListOptionOrderCreate"] = 2] = "TagListOptionOrderCreate";
    Commonv2_TagListOption[Commonv2_TagListOption["TagListOptionCreatedUid"] = 3] = "TagListOptionCreatedUid";
    Commonv2_TagListOption[Commonv2_TagListOption["TagListOptionOwnerUid"] = 4] = "TagListOptionOwnerUid";
    Commonv2_TagListOption[Commonv2_TagListOption["TagListOptionPrivilegeType"] = 5] = "TagListOptionPrivilegeType";
    Commonv2_TagListOption[Commonv2_TagListOption["TagListOptionIds"] = 6] = "TagListOptionIds";
  })(Commonv2_TagListOption || (Commonv2_TagListOption = {}));

  return Commonv2_TagListOption;
}();
export var Commonv2_GetCategoryListV2Req_ListOption = function () {
  //__ENUM_IIFE__
  var Commonv2_GetCategoryListV2Req_ListOption;

  (function (Commonv2_GetCategoryListV2Req_ListOption) {
    Commonv2_GetCategoryListV2Req_ListOption[Commonv2_GetCategoryListV2Req_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Commonv2_GetCategoryListV2Req_ListOption[Commonv2_GetCategoryListV2Req_ListOption["ListOptionCategoryTypes"] = 1] = "ListOptionCategoryTypes";
    Commonv2_GetCategoryListV2Req_ListOption[Commonv2_GetCategoryListV2Req_ListOption["ListOptionIsDisable"] = 2] = "ListOptionIsDisable";
    Commonv2_GetCategoryListV2Req_ListOption[Commonv2_GetCategoryListV2Req_ListOption["ListOptionIds"] = 3] = "ListOptionIds";
    Commonv2_GetCategoryListV2Req_ListOption[Commonv2_GetCategoryListV2Req_ListOption["ListOptionCategoryName"] = 4] = "ListOptionCategoryName";
  })(Commonv2_GetCategoryListV2Req_ListOption || (Commonv2_GetCategoryListV2Req_ListOption = {}));

  return Commonv2_GetCategoryListV2Req_ListOption;
}();
export var Commonv2_AsyncTaskState = function () {
  //__ENUM_IIFE__
  var Commonv2_AsyncTaskState;

  (function (Commonv2_AsyncTaskState) {
    Commonv2_AsyncTaskState[Commonv2_AsyncTaskState["AsyncTaskStateNil"] = 0] = "AsyncTaskStateNil";
    Commonv2_AsyncTaskState[Commonv2_AsyncTaskState["AsyncTaskStateInProgress"] = 1] = "AsyncTaskStateInProgress";
    Commonv2_AsyncTaskState[Commonv2_AsyncTaskState["AsyncTaskStateSuccess"] = 2] = "AsyncTaskStateSuccess";
    Commonv2_AsyncTaskState[Commonv2_AsyncTaskState["AsyncTaskStateFailure"] = 3] = "AsyncTaskStateFailure";
  })(Commonv2_AsyncTaskState || (Commonv2_AsyncTaskState = {}));

  return Commonv2_AsyncTaskState;
}();
export var Commonv2_GetAsyncTaskListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Commonv2_GetAsyncTaskListReq_ListOption;

  (function (Commonv2_GetAsyncTaskListReq_ListOption) {
    Commonv2_GetAsyncTaskListReq_ListOption[Commonv2_GetAsyncTaskListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Commonv2_GetAsyncTaskListReq_ListOption[Commonv2_GetAsyncTaskListReq_ListOption["ListOptionDateAt"] = 1] = "ListOptionDateAt";
    Commonv2_GetAsyncTaskListReq_ListOption[Commonv2_GetAsyncTaskListReq_ListOption["ListOptionAppTypeList"] = 2] = "ListOptionAppTypeList";
    Commonv2_GetAsyncTaskListReq_ListOption[Commonv2_GetAsyncTaskListReq_ListOption["ListOptionTaskKeyList"] = 3] = "ListOptionTaskKeyList";
    Commonv2_GetAsyncTaskListReq_ListOption[Commonv2_GetAsyncTaskListReq_ListOption["ListOptionTaskKey"] = 4] = "ListOptionTaskKey";
    Commonv2_GetAsyncTaskListReq_ListOption[Commonv2_GetAsyncTaskListReq_ListOption["ListOptionTaskState"] = 5] = "ListOptionTaskState";
  })(Commonv2_GetAsyncTaskListReq_ListOption || (Commonv2_GetAsyncTaskListReq_ListOption = {}));

  return Commonv2_GetAsyncTaskListReq_ListOption;
}();
export var Commonv2_Device = function () {
  //__ENUM_IIFE__
  var Commonv2_Device;

  (function (Commonv2_Device) {
    Commonv2_Device[Commonv2_Device["DeviceNil"] = 0] = "DeviceNil";
    Commonv2_Device[Commonv2_Device["DeviceMobile"] = 1] = "DeviceMobile";
    Commonv2_Device[Commonv2_Device["DevicePc"] = 2] = "DevicePc";
  })(Commonv2_Device || (Commonv2_Device = {}));

  return Commonv2_Device;
}(); // @desc: 操作系统

export var Commonv2_OperatingSystem = function () {
  //__ENUM_IIFE__
  var Commonv2_OperatingSystem;

  (function (Commonv2_OperatingSystem) {
    Commonv2_OperatingSystem[Commonv2_OperatingSystem["OperatingSystemNil"] = 0] = "OperatingSystemNil";
    Commonv2_OperatingSystem[Commonv2_OperatingSystem["OperatingSystemWindows"] = 1] = "OperatingSystemWindows";
    Commonv2_OperatingSystem[Commonv2_OperatingSystem["OperatingSystemMac"] = 2] = "OperatingSystemMac";
    Commonv2_OperatingSystem[Commonv2_OperatingSystem["OperatingSystemAndroid"] = 3] = "OperatingSystemAndroid";
    Commonv2_OperatingSystem[Commonv2_OperatingSystem["OperatingSystemIos"] = 4] = "OperatingSystemIos";
  })(Commonv2_OperatingSystem || (Commonv2_OperatingSystem = {}));

  return Commonv2_OperatingSystem;
}();